<template>
  <div id="app">
    <div class="bg"></div>
    <div class="footer">
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">蒙ICP备2021004646号-1</a>
    </div>
    <!-- <div class="footer">蒙ICP备2021004646号-2</div> -->
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}
.bg {
  background-image: url('./assets/index.jpg');
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
}
.footer {
  /* font-size: 16px; */
  color: #939393;
  text-align: center;
  margin: 5px 0;
  a {
    text-decoration: none;
    color: #939393;
  }
}
</style>
